import { Stack } from '@mui/material';
import { Field, FormikProps } from 'formik';
import { TextField } from 'formik-mui';
import { FormValues } from '../tag.form-tools';
import { ColorPickerField } from 'shared/ui/color-picker';


export const TagFormFields = (props: FormikProps<FormValues>) => {

  return (
    <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
      <Field
        name='name'
        label='Название тэга'
        required
        fullWidth
        component={TextField}
      />
      <Field name='color' required label={'Цвет'} component={ColorPickerField} />
    </Stack>
  );
};
